var plugin_rtlignore_default = {
  "alignLeft": "-k25b",
  "textWrapNowrap": "Ci5C-",
  "alignRight": "wyvbD",
  "alignCenter": "OMJPo",
  "sizeFullWidth": "_2euu0",
  "renderedInTable": "cSKKK",
  "sizeOriginal": "DTMno",
  "sizeContent": "hcTvg",
  "sizeSmall": "lnT9K",
  "sizeSmallCenter": "KNuoO",
  "flex": "Z-1cz",
  "atomic": "MJDno",
  "embed": "ERkHd",
  "horizontalScrollbar": "EF-P6",
  "pluginContainerMobile": "K-SK-"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
